export const getSavedPrintInfo = (state) =>
  state.printConfirm?.rawPrintData || {};

export const getSavedDeliveryMethod = (state) =>
  state.printConfirm?.rawPrintData?.deliveryMethodData[0]?.deliveryMethodName ||
  undefined;
